module.exports = "span {\n    color: red;\n    font-size: 12px;\n}\n\n.mt-1 {\n    margin-top: 10px;\n}\n\n/* .pwd-input input {\n    border-right: none;\n}\n\n.pwd-input span {\n    background: none;\n    cursor: pointer;\n    padding: 4px 9px;\n    border: solid 1.5px #c3ced8;\n    border-left: none;\n}\n\n.pwd-input span.active img {\n    content: url(../../../assets/img/eyeicon-visible.svg);\n} */\n\n/* \ninput.ng-invalid.ng-touched span {\n    border: 1px solid red;\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/signinsignup/signup.component.css
// module id = ./src/app/auth/signinsignup/signup.component.css
// module chunks = main